export default {
  "foot": {
    "title": "Century Games Spelers",
    "p1": "Voer je Gebruikers-ID in en betaal voor de top-up. Het bedrag zal direct worden ververst in het gekoppelde account. Mocht dit niet het geval zijn, start het spel dan opnieuw op of neem contact op met onze klantenservice.",
    "p2": "Als je vragen hebt, neem dan gerust contact op met de klantenservice. Bedankt voor je steun!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Gebruiksvoorwaarden",
    "policy": "Privacybeleid",
    "descriptionTitle": "Hoe werkt dit?"
  },
  "accept": {
    "title": "Deze website gebruikt cookies om je browse-ervaring te verbeteren. Lees ons <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Privacybeleid</a> voor informatie over wat we verzamelen op onze website. Door deze site te blijven gebruiken, ga je ermee akkoord dat we cookies op je apparaat mogen opslaan en openen.",
    "decline": "Afwijzen",
    "accept": "Accepteren"
  },
  "game": {
    "inapptext": "Of meld je aan in het Spel",
    "loginfail": "Aanmelden Mislukt",
    "logintip": "Als het spel niet geautoriseerd kon worden, update dan het spel naar de nieuwste versie of probeer een andere browser.",
    "reloadmsg": "Tik op de knop 'Herladen' om aan te melden.",
    "reload": "Herladen",
    "appnotice": "Als je wilt aanmelden via de game-app, gebruik dan een externe browser om de store te openen.",
    "changeaccount": "Weet je zeker dat je wilt afmelden van je account?",
    "login": "Aanmelden",
    "notice": "Melding",
    "confirm": "Bevestigen",
    "loginuserid": "Gebruikers-ID",
    "palceholder": "Voer Gebruikers-ID in",
    "okbtn": "OK",
    "loginbtn": "Aanmelden via Spel",
    "changebtn": "Of Aanmelden met Gebruikers-ID",
    "useTitle": "ACCOUNT",
    "checkBtn": "Controleren",
    "findid": "Gebruikers-ID niet gevonden?",
    "checktext": "Je kunt het normaal gesproken vinden in de instellingen. Tik op het vraagteken voor meer begeleiding.",
    "username": "Nickname:",
    "userId": "Gebruikers-ID:",
    "packageTitle": "TOP-UP BEDRAG",
    "edit": "Bewerken",
    "paymentTitle": "BETAALWIJZE",
    "total": "Totaal",
    "goPay": "Nu Betalen",
    "noSelectPackageTips": "Je hebt geen bedrag geselecteerd",
    "payFail": "BETALING MISLUKT",
    "camelPayfail": "Betaling Mislukt",
    "payFailTips1": "Neem aub contact op met Adyen Klantenservice",
    "payFailTips2": "Neem aub contact op met PayPal Klantenservice",
    "paySuccess": "BETALING GELUKT",
    "paySuccessTips2": "Laad het spel eerst opnieuw voordat je contact opneemt met de Klantenservice voor het niet ontvangen van je aankoop!",
    "camelPaySuccess": "Betaling Gelukt",
    "transactionId": "Transactie ID",
    "paySuccessTips": "De levering van het item kan even duren, wacht alstublieft.",
    "deliveryFail": "LEVERING MISLUKT",
    "deliveryFailTips": "Neem contact op met de Klantenservice",
    "orderTitle": "Jouw bestelling",
    "paidWith": "Betaalwijze",
    "orderID": "Transactie ID",
    "payStatus": "Betalingsstatus",
    "orderTotal": "Totale Prijs",
    "transactionDate": "Datum van transactie",
    "goOnPay": "Opnieuw Kopen",
    "getInvoice": "Factuur",
    "camelDeliveryFail": "Leveringsfout",
    "confirmOrder": "BESTELLINGSBEVESTIGING",
    "confirmFollow": "Bevestig aub het volgende:",
    "nickname": "Nickname ",
    "packageName": "Items",
    "totalPayment": "Totale Prijs",
    "confirmPayWith": "Betaalwijze",
    "confirmAndGoOn": "Bevestigen & Doorgaan met Aankoop",
    "orderCancel": "Annuleren",
    "getInvoiceTitle": "VERSTUUR PER EMAIL",
    "getInvoiceTips": "Als je de factuur per e-mail wilt ontvangen, voer dan een e-mailadres in.",
    "getInvoiceTips1": "Voer je e-mailadres in om de factuur te ontvangen.",
    "getInvoiceTips2": "Ga akkoord met het verzamelen en opslaan van je e-mailadres.",
    "getInvoiceTips3": "Ga akkoord om e-mails te ontvangen over kortingen, promoties en meer voor onze spellen.",
    "invoiceSend": "Versturen",
    "sendSuccess": "Factuur verzonden per e-mail",
    "id404": "Gebruikers-ID niet gevonden",
    "packageLoadingText": "winkelitems verversen...",
    "taxTips": "De prijzen zijn inclusief BTW",
    "adyenTips": "De betaaldienst wordt geleverd door Adyen, dat opereert onder een bankvergunning en wordt gecontroleerd door De Nederlandsche Bank. Als je vragen hebt over de certificeringen, raadpleeg dan <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Voor informatie over hoe zij je gegevens beschermen, raadpleeg <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "De betaaldienst wordt geleverd door PayPal. Voor informatie over hoe zij je gegevens beschermen, raadpleeg <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>.",
    "switchCountryTips": "Je voorkeursland/regio is ${servercountry}. Wil je van land en valuta wisselen?",
    "paypalBtn": "Nu Betalen met Kaart",
    "paypalOr": "Of",
    "paypalCard1": "Naam Kaarthouder",
    "paypalCard2": "Kaartnummer",
    "checkUserID": "Link",
    "success": "GELUKT",
    "changeCurrencyContent": "Wil je de regio en valuta wijzigen om overeen te komen met je in-game instelling: ${servercountry}?",
    "productDescription": "Boerenduiten zijn een valuta die je kunt gebruiken om alle pakketten en aanbiedingen in het spel te kopen.",
    "payButton": "BETALEN",
    "userIdNotice": "Voer je Gebruikers-ID in om eerst je spelaccount te koppelen",
    "account": "Account",
    "card": "Betaalpas",
    "notification": "Voer je gebruikers-ID in om je account te koppelen, selecteer de gewenste items en betaal met de betaalwijze van jouw keuze. Na het herladen van het spel zullen de gekochte items in je account verschijnen, klaar voor gebruik.\n\nAls je vragen hebt, neem dan gerust contact op met de klantenservice in het spel.",
    "rongluRank": "Oven Level:",
    "tips": "Hoe kun je het gebruiken?",
    "checkTIps1": "Ik heb de <a :href=\"policyUrl\">\"Privacyverklaring\"</a>, <a :href=\"serviceURl\">\"Servicevoorwaarden\"</a> en <a :href=\"paymentURl\">\"Betaalvoorwaarden\"</a> gelezen en ga akkoord.",
    "checkTIps2": "Lees en vink het vakje aan",
    "selectTips": "(Valuta van de meest recente in-game aankoop wordt geselecteerd)",
    "koPayTips": "Als je bankkaart de Zuid-Koreaanse Won als vreemde valuta gebruikt, zal de dienst Dynamische Valutaconversie (DCC) worden toegepast, en kunnen er extra verwerkingskosten in rekening worden gebracht door een derde partij en niet door deze website.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Factuur",
    "transactionId": "Transactie ID",
    "transactionDate": "Datum van Transactie",
    "totalAmount": "Totaalbedrag",
    "paymentMethod": "Betaalwijze",
    "description": "Bechrijving",
    "game": "Spel",
    "quantity": "Aantal",
    "price": "Prijs",
    "amount": "Bedrag",
    "total": "Totaalbedrag",
    "footTitle": "Opmerkingen",
    "footContent": "Bedankt voor je steun aan Century Games!",
    "button1": "Ontvangstbewijs Ontvangen",
    "button2": "Terug zonder ontvangstbewijs",
    "giveupInvoice": "Je zult geen bon ontvangen voor de bestelling. Bevestigen?"
  },
  "payment": {
    "card": "Credit card / Debit card",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "LAND / REGIO",
    "Africa": "Afrika",
    "America": "Amerika",
    "Asia": "Azië",
    "Europe": "Europa",
    "Oceania": "Oceanië",
    "ZA": "Zuid-Afrika",
    "US": "Verenigde Staten",
    "HK": "Hongkong, China",
    "JP": "Japan",
    "KR": "Korea",
    "SG": "Singapore",
    "SA": "Saoedi-Arabië",
    "IQ": "Irak",
    "TW": "Taiwan, China",
    "TH": "Thailand",
    "GB": "Verenigd Koninkrijk",
    "AU": "Australië",
    "countryLanguage1": "TAAL",
    "AE": "Verenigde Arabische Emiraten",
    "DE": "Duitsland",
    "PT": "Portugal",
    "RU": "Rusland",
    "ES": "Spanje",
    "CH": "Zwitserland",
    "TR": "Turkije",
    "KW": "Koeweit",
    "QA": "Qatar",
    "PL": "Polen",
    "ID": "Indonesië",
    "IT": "Italië",
    "IN": "India",
    "FR": "Frankrijk",
    "CA": "Canada",
    "NL": "Nederland",
    "AT": "Oostenrijk",
    "RS": "Servië",
    "SE": "Zweden",
    "MY": "Maleisië",
    "BE": "België",
    "DK": "Denemarken",
    "FI": "Finland",
    "PH": "Filipijnen",
    "NO": "Noorwegen",
    "BR": "Brazilië",
    "NZ": "Nieuw-Zeeland",
    "UA": "Oekraïne",
    "RO": "Roemenië"
  },
  "extra_info": {
    "kingdom": "Staat: #"
  },
  "adyen": {
    "note": "De betaaldienst wordt geleverd door Adyen, die veilige transacties biedt met het hoogste niveau van PCI-DSS-certificering van internationale creditcardorganisaties, en zowel binnenlandse als buitenlandse kaartbetalingen ondersteunt.",
    "note2": "Opmerking: Vink \"Bewaar voor mijn volgende betaling\" aan om je betaalgegevens op te slaan in je huidige browser voor toekomstige betalingen."
  },
  "pay": {
    "error1": "Als er iets misgaat, probeer het dan later opnieuw of gebruik een andere betaalmethode. Neem contact op met de klantenservice als je nog vragen hebt."
  },
  "meta": {
    "title": "Family Farm Adventure Winkel",
    "description": "De Family Farm Adventure Winkel is de officiële winkel van Family Farm Adventure, en biedt een korting op het opwaarderen van de game en in-game pakketten voor spelers.",
    "keywords": "boerderij, teelt, markt, upgrade, verkenning, kaart, karakter, niveau, simulatie, strategie, betalen, winkel, opwaarderen, betaling."
  }
};


// WEBPACK FOOTER //
// ./src/lang/NL.js